export const DATEPICKER = {
    MONTH: [ "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
}

export const CONSTANTS_PAGINATION = {
    nCurrentPage: 1,
    nItemsPerPage: 10,
    selectableItemsPerPage: [10, 25, 50, 100, 500, 1000],
    allRegister: {
        description: "Todos",
        value: 999999999
    }
  };
  